import { render, staticRenderFns } from "./SuppliersForm.vue?vue&type=template&id=0ae1b064&scoped=true&"
import script from "./SuppliersForm.vue?vue&type=script&lang=js&"
export * from "./SuppliersForm.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersForm.vue?vue&type=style&index=0&id=0ae1b064&lang=scss&scoped=true&"
import style1 from "./SuppliersForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae1b064",
  null
  
)

export default component.exports